













import Vue from 'vue';
import DocumentBoxBase from '../document/DocumentBoxBase.vue';

export default Vue.extend({
    components: { DocumentBoxBase },
    props: {
        moduleName: {
            type: String,
            required: true,
        },
        folderName: {
            type: String,
            required: true,
        },
        fileName: {
            type: String,
            required: false,
        },
        fileExtension: {
            type: String,
            required: false,
        },
        accept: {
            type: String,
            required: false
        },
        multiple: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        applicationName() {
            return require('../../../package.json').name;
        },
        divisionName() {
            return 'default';
        },
    }
});
